"use client";

import { useAppDispatch, useAppStore } from "@/redux/hooks";
import { setArticleData, setArticleSlug, setDevice } from "@/components/ArticlePage/redux/slice";

const useSyncArticleData = ({ ArticleData, ua, articleSlug }) => {
  const dispatch = useAppDispatch();
  const store: any = useAppStore();

  if (store?.getState()?.article?.articleSlug === articleSlug) {
    return;
  } else {
    dispatch(setArticleData(ArticleData));
    dispatch(setDevice(ua));
    dispatch(setArticleSlug(articleSlug));
  }
};

export { useSyncArticleData };
